export default "__VITE_ASSET__b1f500ba__"